import { FILTERS } from './evidenceFilters';

export const RYCZALT_SALES_LISTING_FILTERS = {
  path: '/evidences/ryczalt-sales',
  filters: FILTERS,
};
